import i18next from 'i18next';

import { getAccountId } from '../api/DistUI';
import PlanGroupIds from '../constants/planGroupIds';

let customerIdCache;
const waitForAccountId = async () => {
  customerIdCache = customerIdCache || (await getAccountId());
};

waitForAccountId();

export const getPlanName = ({ planName, planGroupId, header, onlyText }) => {
  // For the plan blocks which require a larger logo
  const emailPlusNameLarge = (planItemIndex) => {
    return (
      <div data-qe-id="email-plus-badge-large-text">
        {i18next.t(`comparison-table.plan_blocks.${planItemIndex}.plus`)}
      </div>
    );
  };

  // For the tables which require a smaller logo
  const emailPlusNameBase = (planItemIndex) => {
    return <div>{i18next.t(`comparison-table.plan_blocks.${planItemIndex}.plus`)}</div>;
  };

  if (!planName) {
    return '';
  }

  let planItemIndex = 'email_plus';

  if (planGroupId === PlanGroupIds.START_PLANGROUP_ID) {
    planItemIndex += '_v19';
  } else if (planGroupId === PlanGroupIds.NEW_FEATURE_PACKAGE_MIX) {
    planItemIndex += '_NewMix';
  } else if (planGroupId === PlanGroupIds.V20_PLANGROUP_ID) {
    planItemIndex += '_v20';
  }

  // TODO: Make sure reading the name from description is right way.
  // Because observed some account's plans does not have EMAIL PLUS in description.
  const name = planName.indexOf('-') > -1 ? planName.split(/\s-\s(.*)/g)[1] : planName;
  const displayName = name.charAt(0).toUpperCase() + name.slice(1);

  // Expecting the 'PLUS' will be the part of description in a plan.
  if (displayName.indexOf('PLUS') > -1 && !onlyText) {
    if (header) {
      return emailPlusNameBase(planItemIndex);
    }

    return emailPlusNameLarge(planItemIndex);
  }

  return displayName;
};

export const transformCustomerInfo = (billingInfo, currency) => {
  const { customer_info: customerInfo, overview } = billingInfo;

  return {
    customer: {
      customerId: customerIdCache,
      userUuid: null,
      firstname: customerInfo.first_name,
      lastname: customerInfo.last_name,
      companyname: customerInfo.company_name,
      email: customerInfo.email,
      phone: customerInfo.phone,
      address1: customerInfo.address1,
      address2: customerInfo.address2,
      city: customerInfo.city,
      state: customerInfo.state,
      country: customerInfo.country,
      zipcode: customerInfo.postal_code4
        ? `${customerInfo.postal_code}-${customerInfo.postal_code4}`
        : customerInfo.postal_code,
      contactEmail: overview.account_email_addresses.contact_email_address,
      vatNumber: customerInfo.non_us_tax_exemption_number,
      billingType: {
        name: 'R', // ??
      },
      customerInSingleBilling: false,
      billingLetterOption: customerInfo.billing_letter_option || 'Y',
      currencyCd: currency || 'USD',
      billingPeriod: null,
      billingDayOfMonth: 0,
      addressValidationRequired: true,
      noPrepayAutoRenewOptin: 0,
      addressProvided: true,
      singleBilledAccount: false,
      partnerBilledAccount: false,
    },
    overview: {
      paymentPeriod: overview.payment_period || 1,
    },
  };
};
